const footerDe = {
    "follow_us": "Folgen Sie uns!",
    "all_rights_reserved": "© 2024 Code Kitchen Kft. Alle Rechte vorbehalten.",
    "terms_and_conditions": "Geschäftsbedingungen",
    "privacy_policy": "Datenschutzrichtlinie"
};

export default footerDe;
